import { cloneDeep } from "lodash-es";
import { ResultRow } from "../../../data-structures/results/result-row.model";

export type EarningsKeys = 'RESULTS.DATA.ISPL.EBITDA'
  | 'RESULTS.DATA.ISPL.EBITOI'
  | 'RESULTS.DATA.ISPL.EBTPTI'
  | 'RESULTS.DATA.ISPL.TAX'
  | 'RESULTS.DATA.ISPL.NIPATNE'

interface EarningsInterface {
 'RESULTS.DATA.ISPL.EBITDA'?: EBITDA;
 'RESULTS.DATA.ISPL.EBITOI'?: EBITOI;
 'RESULTS.DATA.ISPL.EBTPTI'?: EBTPTI;
 'RESULTS.DATA.ISPL.TAX'?: ISPLTax;
 'RESULTS.DATA.ISPL.NIPATNE'?: NIPATNE;
}
export class Earnings {
  'RESULTS.DATA.ISPL.EBITDA';
  'RESULTS.DATA.ISPL.EBITOI';
  'RESULTS.DATA.ISPL.EBTPTI';
  'RESULTS.DATA.ISPL.TAX';
  'RESULTS.DATA.ISPL.NIPATNE';
  /** earnings before interest, tax, D&A */
  get ebitda() {
    return this['RESULTS.DATA.ISPL.EBITDA.RESULTS.DATA.ISPL.EBITDA'];
  }
  set ebitda(value: ResultRow) {
    this['RESULTS.DATA.ISPL.EBITDA.RESULTS.DATA.ISPL.EBITDA'] = value;
  }
  /** (earnings before interest and tax) / operating income */
  get ebitoi() {
    return this['RESULTS.DATA.ISPL.EBITOI.RESULTS.DATA.ISPL.EBITOI'];
  }
  set ebitoi(value: ResultRow) {
    this['RESULTS.DATA.ISPL.EBITOI.RESULTS.DATA.ISPL.EBITOI'] = value;
  }
  /** (earnings before tax) / pre-tax income */
  get ebtpti() {
    return this['RESULTS.DATA.ISPL.EBTPTI.RESULTS.DATA.ISPL.EBTPTI'];
  }
  set ebtpti(value: ResultRow) {
    this['RESULTS.DATA.ISPL.EBTPTI.RESULTS.DATA.ISPL.EBTPTI'] = value;
  }
  get tax() {
    return this['RESULTS.DATA.ISPL.TAX.RESULTS.DATA.ISPL.TAX'];
  }
  set tax(value: ResultRow) {
    this['RESULTS.DATA.ISPL.TAX.RESULTS.DATA.ISPL.TAX'] = value;
  }
  /** net income / PAT (profit after tax) / net earnings */
  get nipatne() {
    return this['RESULTS.DATA.ISPL.NIPATNE.RESULTS.DATA.ISPL.NIPATNE'];
  }
  set nipatne(value: ResultRow) {
    this['RESULTS.DATA.ISPL.NIPATNE.RESULTS.DATA.ISPL.NIPATNE'] = value;
  }

  constructor(param: EarningsInterface = {}) {
    this['RESULTS.DATA.ISPL.EBITDA'] = param['RESULTS.DATA.ISPL.EBITDA']
      ? new EBITDA(param['RESULTS.DATA.ISPL.EBITDA'])
      : new EBITDA();

    this['RESULTS.DATA.ISPL.EBITOI'] = param['RESULTS.DATA.ISPL.EBITOI']
      ? new EBITOI(param['RESULTS.DATA.ISPL.EBITOI'])
      : new EBITOI();

    this['RESULTS.DATA.ISPL.EBTPTI'] = param['RESULTS.DATA.ISPL.EBTPTI']
      ? new EBTPTI(param['RESULTS.DATA.ISPL.EBTPTI'])
      : new EBTPTI();

    this['RESULTS.DATA.ISPL.TAX'] = param['RESULTS.DATA.ISPL.TAX']
      ? new ISPLTax(param['RESULTS.DATA.ISPL.TAX'])
      : new ISPLTax();

    this['RESULTS.DATA.ISPL.NIPATNE'] = param['RESULTS.DATA.ISPL.NIPATNE']
      ? new NIPATNE(param['RESULTS.DATA.ISPL.NIPATNE'])
      : new NIPATNE();
  }

  deepCopy() {
    return new Earnings(cloneDeep(this));
  }
}

interface EBITDAInterface {
 'RESULTS.DATA.ISPL.EBITDA'?: ResultRow;
}
class EBITDA {
  'RESULTS.DATA.ISPL.EBITDA': ResultRow;
  constructor(param: EBITDAInterface = {}) {
    this['RESULTS.DATA.ISPL.EBITDA'] = param['RESULTS.DATA.ISPL.EBITDA']
      ? new ResultRow(param['RESULTS.DATA.ISPL.EBITDA'])
      : new ResultRow();
  }

  deepCopy() {
    return new EBITDA(cloneDeep(this));
  }
}

interface EBITOIInterface {
 'RESULTS.DATA.ISPL.EBITOI'?: ResultRow;
}
class EBITOI {
  'RESULTS.DATA.ISPL.EBITOI': ResultRow;
  constructor(param: EBITOIInterface = {}) {
    this['RESULTS.DATA.ISPL.EBITOI'] = param['RESULTS.DATA.ISPL.EBITOI']
      ? new ResultRow(param['RESULTS.DATA.ISPL.EBITOI'])
      : new ResultRow();
  }

  deepCopy() {
    return new EBITOI(cloneDeep(this));
  }
}

interface EBTPTIInterface {
 'RESULTS.DATA.ISPL.EBTPTI'?: ResultRow;
}
class EBTPTI {
  'RESULTS.DATA.ISPL.EBTPTI': ResultRow;
  constructor(param: EBTPTIInterface = {}) {
    this['RESULTS.DATA.ISPL.EBTPTI'] = param['RESULTS.DATA.ISPL.EBTPTI']
      ? new ResultRow(param['RESULTS.DATA.ISPL.EBTPTI'])
      : new ResultRow();
  }

  deepCopy() {
    return new EBTPTI(cloneDeep(this));
  }
}

interface ISPLTaxInterface {
 'RESULTS.DATA.ISPL.TAX'?: ResultRow;
}
class ISPLTax {
  'RESULTS.DATA.ISPL.TAX': ResultRow;
  constructor(param: ISPLTaxInterface = {}) {
    this['RESULTS.DATA.ISPL.TAX'] = param['RESULTS.DATA.ISPL.TAX']
      ? new ResultRow(param['RESULTS.DATA.ISPL.TAX'])
      : new ResultRow();
  }

  deepCopy() {
    return new ISPLTax(cloneDeep(this));
  }
}

interface NIPATNEInterface {
 'RESULTS.DATA.ISPL.NIPATNE'?: ResultRow;
}
class NIPATNE {
  'RESULTS.DATA.ISPL.NIPATNE': ResultRow;
  constructor(param: NIPATNEInterface = {}) {
    this['RESULTS.DATA.ISPL.NIPATNE'] = param['RESULTS.DATA.ISPL.NIPATNE']
      ? new ResultRow(param['RESULTS.DATA.ISPL.NIPATNE'])
      : new ResultRow();
  }

  deepCopy() {
    return new NIPATNE(cloneDeep(this));
  }
}